export default __webpack_public_path__ + "static/media/img-0122-france-full-face.ac0d5cd7.png";